import { render, staticRenderFns } from "./PaymentResult.vue?vue&type=template&id=7b5ad355&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"
import style0 from "./PaymentResult.vue?vue&type=style&index=0&id=7b5ad355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ad355",
  null
  
)

export default component.exports